import React from "react";
import Devlepmenttypes from "../components/Devlepmenttypes";
import Leading from "../components/Leading";
import Nationalvision from "../components/Nationalvision";
import QatarHero from "../components/QatartHero";

function Qatar() {
  return (
    <>
      <QatarHero />
      <Nationalvision />
      <Devlepmenttypes />
      <Leading />
    </>
  );
}

export default Qatar;
